module.exports = "pegasus_template/assets/tech/email1-bg3.png";